import FJTextStyle from './FJTextStyle';
import FJTextShadowOutline from './style/FJTextShadowOutline';

class FJTextStyleOutline extends FJTextStyle {
    initStyles(props = {}) {
        let textOutline = new FJTextShadowOutline({
            ...props,
            position: 'relative',
            color: '#000000',
            width: 50,
            widthRef: 1200,
        });
        this._styles = [textOutline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: *, width: *}}
     */
    getAdjustInfo() {
        let outline = this._styles[0];
        return {
            color: [outline.color],
            width: outline.width,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        info.color.forEach((color, index) => {
            if (color !== '') {
                this._styles[index].color = color;
            }
        });

        if (info.width !== '') {
            this._styles[0].width = info.width;
        }
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach(style => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: false });
        });
    }
}

export default FJTextStyleOutline;
